export const scrollerData = [
  {
    symbol: "HUBC",
    name: "HUB Cyber Security (Israel) Ltd.",
    change: 0.4999,
    price: 1.5399,
    changesPercentage: 48.0673,
  },
  {
    symbol: "MDIA",
    name: "MediaCo Holding Inc.",
    change: 3.12,
    price: 4.52,
    changesPercentage: 226.0869,
  },
  {
    symbol: "SOXS",
    name: "Direxion Daily Semiconductor Bear 3X Shares",
    change: -0.075,
    price: 3.445,
    changesPercentage: -2.1307,
  },
  {
    symbol: "SPCB",
    name: "SuperCom Ltd.",
    change: 0.1299,
    price: 0.3399,
    changesPercentage: 61.8571,
  },
  {
    symbol: "SQQQ",
    name: "ProShares UltraPro Short QQQ",
    change: -0.3,
    price: 10.82,
    changesPercentage: -2.6978,
  },
  {
    symbol: "NKLA",
    name: "Nikola Corporation",
    change: 0.0501,
    price: 1.0001,
    changesPercentage: 5.2737,
  },
  {
    symbol: "CADL",
    name: "Candel Therapeutics, Inc.",
    change: 0.705,
    price: 7.105,
    changesPercentage: 11.0156,
  },
  {
    symbol: "TSLA",
    name: "Tesla, Inc.",
    change: -1.0399,
    price: 170.0701,
    changesPercentage: -0.6077,
  },
  {
    symbol: "AMD",
    name: "Advanced Micro Devices, Inc.",
    change: 4.3801,
    price: 170.2101,
    changesPercentage: 2.6413,
  },
  {
    symbol: "TQQQ",
    name: "ProShares UltraPro QQQ",
    change: 1.63,
    price: 59.45,
    changesPercentage: 2.8191,
  },
  {
    symbol: "SOXL",
    name: "Direxion Daily Semiconductor Bull 3X Shares",
    change: 0.76,
    price: 43.13,
    changesPercentage: 1.7937,
  },

  {
    symbol: "WISA",
    name: "WiSA Technologies, Inc.",
    change: -0.001,
    price: 0.0225,
    changesPercentage: -4.2553,
  },
  {
    symbol: "INTC",
    name: "Intel Corporation",
    change: -1.045,
    price: 38.685,
    changesPercentage: -2.6302,
  },
  {
    symbol: "SPY",
    name: "SPDR S&P 500 ETF Trust",
    change: 3.63,
    price: 516.7,
    changesPercentage: 0.7075,
  },
  {
    symbol: "CISS",
    name: "C3is Inc.",
    change: -0.0022,
    price: 0.0416,
    changesPercentage: -5.0228,
  },
  {
    symbol: "TLRY",
    name: "Tilray Brands, Inc.",
    change: -0.145,
    price: 2.535,
    changesPercentage: -5.4187,
  },
  {
    symbol: "SBFM",
    name: "Sunshine Biopharma, Inc.",
    change: 0.0171,
    price: 0.1091,
    changesPercentage: 18.6681,
  },
  {
    symbol: "EGOX",
    name: "Next.e.GO N.V. Ordinary Shares",
    change: 0.0007,
    price: 0.03,
    changesPercentage: 2.3891,
  },
  {
    symbol: "PLUG",
    name: "Plug Power Inc.",
    change: 0.015,
    price: 3.165,
    changesPercentage: 0.4762,
  },
  {
    symbol: "SINT",
    name: "Sintx Technologies, Inc.",
    change: -0.0008,
    price: 0.0243,
    changesPercentage: -3.1873,
  },
  {
    symbol: "SLV",
    name: "iShares Silver Trust",
    change: 0.5,
    price: 24.99,
    changesPercentage: 2.0416,
  },
  {
    symbol: "NVDA",
    name: "NVIDIA Corporation",
    change: 12.36,
    price: 871.41,
    changesPercentage: 1.4388,
  },
  {
    symbol: "AMZN",
    name: "Amazon.com, Inc.",
    change: 5.14,
    price: 185.14,
    changesPercentage: 2.8556,
  },
  {
    symbol: "ABEV",
    name: "Ambev S.A.",
    change: -0.075,
    price: 2.375,
    changesPercentage: -3.0569,
  },
  {
    symbol: "QQQ",
    name: "Invesco QQQ Trust",
    change: 4.12,
    price: 439.46,
    changesPercentage: 0.9464,
  },
  {
    symbol: "SOUN",
    name: "SoundHound AI, Inc.",
    change: 0.04,
    price: 5.31,
    changesPercentage: 0.7583,
  },
  {
    symbol: "F",
    name: "Ford Motor Company",
    change: 0.01,
    price: 13.22,
    changesPercentage: 0.0757,
  },
  {
    symbol: "MARA",
    name: "Marathon Digital Holdings, Inc.",
    change: 0.6101,
    price: 19.0801,
    changesPercentage: 3.3032,
  },
  {
    symbol: "UVXY",
    name: "ProShares Ultra VIX Short-Term Futures ETF",
    change: 0.1436,
    price: 7.1536,
    changesPercentage: 2.0495,
  },
  {
    symbol: "PLTR",
    name: "Palantir Technologies Inc.",
    change: 0.575,
    price: 23.055,
    changesPercentage: 2.5573,
  },
  {
    symbol: "RIVN",
    name: "Rivian Automotive, Inc.",
    change: 0.16,
    price: 10.29,
    changesPercentage: 1.5795,
  },
  {
    symbol: "ACB",
    name: "Aurora Cannabis Inc.",
    change: -0.69,
    price: 6.37,
    changesPercentage: -9.7734,
  },
  {
    symbol: "BCS",
    name: "Barclays PLC",
    change: -0.0095,
    price: 9.7005,
    changesPercentage: -0.0978,
  },
  {
    symbol: "AAPL",
    name: "Apple Inc.",
    change: 0.42,
    price: 169.24,
    changesPercentage: 0.2488,
  },
  {
    symbol: "SPXS",
    name: "Direxion Daily S&P 500 Bear 3X Shares",
    change: -0.1802,
    price: 9.0998,
    changesPercentage: -1.9438,
  },
  {
    symbol: "XXII",
    name: "22nd Century Group, Inc.",
    change: 0.54,
    price: 2.02,
    changesPercentage: 36.4865,
  },
  {
    symbol: "IWM",
    name: "iShares Russell 2000 ETF",
    change: 0.33,
    price: 204.1,
    changesPercentage: 0.1619,
  },
  {
    symbol: "WBD",
    name: "Warner Bros. Discovery, Inc.",
    change: -0.1694,
    price: 8.2706,
    changesPercentage: -2.0061,
  },
  {
    symbol: "SPXU",
    name: "ProShares UltraPro Short S&P500",
    change: -0.1461,
    price: 6.7239,
    changesPercentage: -2.1248,
  },
  {
    symbol: "TZA",
    name: "Direxion Daily Small Cap Bear 3X Shares",
    change: -0.09,
    price: 18.39,
    changesPercentage: -0.4867,
  },
  {
    symbol: "TLT",
    name: "iShares 20+ Year Treasury Bond ETF",
    change: -0.9,
    price: 91.78,
    changesPercentage: -0.971,
  },
  {
    symbol: "IBIT",
    name: "iShares Bitcoin Trust",
    change: 0.0416,
    price: 39.1216,
    changesPercentage: 0.1064,
  },
  {
    symbol: "GDX",
    name: "VanEck Gold Miners ETF",
    change: 0.895,
    price: 33.675,
    changesPercentage: 2.7316,
  },
  {
    symbol: "QID",
    name: "ProShares UltraShort QQQ",
    change: -0.175,
    price: 9.165,
    changesPercentage: -1.8744,
  },
  {
    symbol: "VXX",
    name: "iPath Series B S&P 500 VIX Short-Term Futures ETN",
    change: 0.185,
    price: 14.18,
    changesPercentage: 1.3228,
  },
  {
    symbol: "SOFI",
    name: "SoFi Technologies, Inc.",
    change: 0.095,
    price: 7.405,
    changesPercentage: 1.2996,
  },
  {
    symbol: "MU",
    name: "Micron Technology, Inc.",
    change: -1.16,
    price: 122.93,
    changesPercentage: -0.9348,
  },
  {
    symbol: "CCL",
    name: "Carnival Corporation & plc",
    change: -0.05,
    price: 15.01,
    changesPercentage: -0.3321,
  },
  {
    symbol: "T",
    name: "AT&T Inc.",
    change: -0.145,
    price: 17.425,
    changesPercentage: -0.8253,
  },
];
